import React, { useEffect, useState } from "react";
import ApiGet from "api/ApiGet";
import { responseResult } from "utils/ResponseStatus";
import { uAPI } from "api/config";
import chooseUs from 'assets/images/dummy/choose-us.png';
import chooseUsLoc from 'assets/images/icons/chooseus-loc.svg';
import chooseUsMap from 'assets/images/icons/chooseus-map.svg';
import chooseUsCheck from 'assets/images/icons/chooseus-check.svg';
import chooseUsHand from 'assets/images/icons/chooseus-hand.svg';
import chooseUsPelindo from 'assets/images/icons/chooseus-pelindo.svg';
import { APIweb } from "api/config";
import { Link, useLocation } from "react-router-dom";
import { scrollDown } from "utils/ScrollDown";
import { useTranslation } from 'react-i18next';

const ChooseUs = (props) => {
    const [state, setState] = useState(null);
    const lang = localStorage.getItem('i18nextLng');
    const { t, i18n } = useTranslation(); 

    useEffect(() => {
        ApiGet.actions.ChooseUs()
            .then((response) => {
                console.log('ChooseUs response', response)
                if (responseResult(response)) {
                    setState(responseResult(response))
                }
            })
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <div className="choose-us">
                <img src={uAPI + state?.pic} alt="choose-us" style={{ width: '100%' }} />
                <div className="flex flex-wrap flex-row justify-start md:justify-between">
                {
                    state?.detail?.length > 0 && state?.detail?.map((val, ind) => {
                        return (
                        <>
                            {/* <div key={ind} className="flex flex-col m-5 w-[350px]">
                                <div className="flex flex-row items-center h-[60px] mb-2">
                                    {
                                        val?.icon && <div className="mr-4">
                                            <img src={uAPI + val?.icon} alt={val?.alt_icon} width={40} height={40} />
                                        </div>
                                    }
                                    <div className={`text-[18px] font-bold`} style={{
                                        color: val?.color
                                    }}>{val?.value_name}</div>
                                </div>
                                <div className="text-[#5F6B72] text-[14px] text-justify">{lang === "en" ? (val?.description_en ? val?.description_en : val?.description) : val?.description}</div>
                            </div> */}
                        
                            <div className="flex flex-col m-9 w-[350px]">
                                <Link to={val?.alt_icon || ""} className="flex flex-row items-center h-[60px] cursor-pointer" >
                                    <div className="mr-3 mt-[-25px]">
                                        <img src={uAPI + val?.icon} alt={""}  />
                                    </div>
                                    <div className="flex flex-col w-[220px]">
                                        <div className="text-[#0275BC] text-[18px] font-semibold">{val?.value_name}</div>
                                        <div className="text-[#333333] text-[14px] text-justify">{lang === "en" ? (val?.description_en ? val?.description_en : val?.description) : val?.description}</div>
                                    </div>
                                </Link>
                            </div>
                        </>
                        )
                    })
                }
                </div>
                {/* <div className="top-left">
                    <Link to={'/fasilitas'} className="flex flex-row cursor-pointer" >
                        <div className="mr-2">
                            <img src={chooseUsLoc} alt='choose-us-loc' />
                        </div>
                        <div className="flex flex-col w-[220px]">
                            <div className="text-[#0275BC] text-[18px] font-semibold">{t('chooseUsLoc01')}</div>
                            <div className="text-[#333333] text-[14px] text-justify">{t('chooseUsLoc02')}</div>
                        </div>
                    </Link>
                </div>
                <div className="bottom-left">
                    <Link to={'/wilayah-kerja-anak-perusahaan'} className="flex flex-row cursor-pointer" >
                        <div className="mr-2">
                            <img src={chooseUsMap} alt='choose-us-map' />
                        </div>
                        <div className="flex flex-col w-[220px]">
                            <div className="text-[#0275BC] text-[18px] font-semibold">{t('chooseUsMap01')}</div>
                            <div className="text-[#333333] text-[14px] text-justify">{t('chooseUsMap02')}</div>
                        </div>
                    </Link>
                </div>
                <div className="top-right">
                    <Link to={'/penghargaan'} className="flex flex-row cursor-pointer" >
                        <div className="mr-2">
                            <img src={chooseUsCheck} alt='choose-us-check' />
                        </div>
                        <div className="flex flex-col w-[220px]">
                            <div className="text-[#0275BC] text-[18px] font-semibold">{t('chooseUsCheck01')}</div>
                            <div className="text-[#333333] text-[14px] text-justify">{t('chooseUsCheck02')}</div>
                        </div>
                    </Link>
                </div>
                <div className="bottom-right">
                    <Link to={'/logistic-cargo-service'} className="flex flex-row cursor-pointer" >
                        <div className="mr-2">
                            <img src={chooseUsHand} alt='choose-us-hand' />
                        </div>
                        <div className="flex flex-col w-[220px]">
                            <div className="text-[#0275BC] text-[18px] font-semibold">{t('chooseUsHand01')}</div>
                            <div className="text-[#333333] text-[14px] text-justify">{t('chooseUsHand02')}</div>
                        </div>
                    </Link>
                </div>
                <div className="centered-bottom">
                    <div className="flex flex-rowc cursor-pointer" onClick={() => scrollDown(props.scroll)}>
                        <div className="mr-2">
                            <img src={chooseUsPelindo} alt='choose-us-pelindo' />
                        </div>
                        <div className="flex flex-col w-[220px]" >
                            <div className="text-[#0275BC] text-[18px] font-semibold">{t('chooseUsPelindo01')}</div>
                            <div className="text-[#333333] text-[14px] text-justify">{t('chooseUsPelindo02')}</div>
                        </div>
                    </div>
                </div> */}
                {/* <div className="flex flex-col items-center md:hidden">
                    <Link to={'/fasilitas'} target="_blank" className="flex flex-row w-[350px] m-2 items-center">
                        <div className="mr-2">
                            <img src={chooseUsLoc} alt='choose-us-loc' />
                        </div>
                        <div className="flex flex-col">
                            <div className="text-[#0275BC] text-[18px] font-semibold">{t('chooseUsLoc01')}</div>
                        </div>
                    </Link>
                    <Link to={'/wilayah-kerja-anak-perusahaan'} target="_blank" onUpdate={() => window.scrollTo(0, 0)} className="flex flex-row w-[350px] m-2 items-center">
                        <div className="mr-2">
                            <img src={chooseUsMap} alt='choose-us-map' />
                        </div>
                        <div className="flex flex-col">
                            <div className="text-[#0275BC] text-[18px] font-semibold">Wilayah Operasi yang Luas</div>
                        </div>
                    </Link>
                    <Link to={'/penghargaan'} target="_blank" className="flex flex-row w-[350px] m-2 items-center">
                        <div className="mr-2">
                            <img src={chooseUsCheck} alt='choose-us-check' />
                        </div>
                        <div className="flex flex-col">
                            <div className="text-[#0275BC] text-[18px] font-semibold">Perusahaan yang tersertifikasi</div>
                        </div>
                    </Link>
                    <Link to={'/logistic-cargo-service'} target="_blank" className="flex flex-row w-[350px] m-2 items-center">
                        <div className="mr-2">
                            <img src={chooseUsHand} alt='choose-us-hand' />
                        </div>
                        <div className="flex flex-col">
                            <div className="text-[#0275BC] text-[18px] font-semibold">End to End Services</div>
                        </div>
                    </Link>
                    <div className="flex flex-row w-[350px] m-2 items-center cursor-pointer" onClick={() => scrollDown(props.scroll)}>
                        <div className="mr-2">
                            <img src={chooseUsPelindo} alt='choose-us-pelindo' />
                        </div>
                        <div className="flex flex-col">
                            <div className="text-[#0275BC] text-[18px] font-semibold">Bagian dari Pelindo Group</div>
                        </div>
                    </div>
                </div> */}
            </div>
        </>
    )
}
export default ChooseUs;